<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import URL from '@/views/mis/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  import axios from 'axios'
  import textarea from "../../IM/model/textarea";
  let platFromList=[];//适用平台
  let termList=[];//有效期
  let accountTypeList=[];//适用用户
  let changeStatusList=[];//转换度
  let isActiveList=[];//激活状态
  let userLevel=[];//账户等级
  let position=[];//广告位置
  let channel=[];//渠道
  let change={"1":"真实模拟转换","2":"模拟-有转换","3":"模拟-未转换","4":"真实-有转换","5":"真实-未转换"};//转换度
  let changeStatusAccount=[{"key":"1","value":"真实模拟转换"}];
  let positionType={"1":"图片","2":"文字"}
  let dfreList=[];//dfre
  let cfVn=[];//cfVn
  let informationPackage=[];//资讯包
  let carapace=[];//马甲包
  let tcList=[];//tc
  let stockPackage=[];//股票包
  let multiService=[];//多业务
  let kyy=[];//快应用
  let channelOptionList=[];//广告渠道及渠道app
  let channelAppList=[]//广告渠道app

  const cascaderProps = {
    expandTrigger: 'hover',
    multiple: true, 
    collapse: true, 
    emitPath: false,
  }

  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
          if(clickName =="delete"){
              this.$confirm(window.$t("common.ifDelete"), window.$t("common.tip"), {
                  distinguishCancelAndClose: true,
                  confirmButtonText: window.$t("common.ok"),
                  cancelButtonText: window.$t("common.canceld")
              }).then(() => {
                  this.$axios.get(URL.advertising.del+"?id="+row.id).then(res=> {
                      if (res.code == 0) {
                          this.$message.success("suc");
                          this.$refs.childTable.defaultGetData(this.queryData);
                      }
                  });
                  })

          }else if (clickName == "update"){
            let rowStr=JSON.parse(JSON.stringify(row));
            let updRow=JSON.parse(row.adverInfo);
              rowStr.time=[];
              rowStr.param1=[];
              rowStr.param2=[];
              rowStr.param3=[];
            if(typeof rowStr.channel =="string"){
              if(rowStr.channel.indexOf(",")!=-1){
                  rowStr.channel=rowStr.channel.split(",");
              }else{
                   let channel1=[];
                   channel1.push(rowStr.channel);
                  rowStr.channel=channel1;
              }
            }
            if(typeof rowStr.userLevel =="string") {
                if (rowStr.userLevel.indexOf(",") != -1) {
                    rowStr.userLevel = rowStr.userLevel.split(",");
                } else {
                    let userLevel1 = [];
                    userLevel1.push(rowStr.userLevel);
                    rowStr.userLevel = userLevel1;
                }
            }
            if(typeof rowStr.isActive =="string") {
                if (rowStr.isActive.indexOf(",") != -1) {
                    rowStr.isActive = rowStr.isActive.split(",");
                } else {
                    let isActive1 = [];
                    isActive1.push(rowStr.isActive);
                    rowStr.isActive = isActive1;
                }
            }
            if(typeof rowStr.platform =="string") {
                if (rowStr.platform.indexOf(",") != -1) {
                    rowStr.platform = rowStr.platform.split(",");
                } else {
                    let platform1 = [];
                    platform1.push(rowStr.platform);
                    rowStr.platform = platform1;
                }
            }
            if(typeof rowStr.accountType =="string") {
                if (rowStr.accountType.indexOf(",") != -1) {
                    rowStr.accountType = rowStr.accountType.split(",");
                } else {
                    let accountType1 = [];
                    accountType1.push(rowStr.accountType);
                    rowStr.accountType = accountType1;
                }
            }
              rowStr.sort=updRow.sort;
              rowStr.positionType=parseInt(updRow.adType);
              rowStr.url=updRow.imgUrl;
              rowStr.address=updRow.linkUrl;
              rowStr.title=updRow.title;
              rowStr.content=updRow.content;
              rowStr.time.push(rowStr.startTime);
              rowStr.time.push(rowStr.endTime);
            if(rowStr.aboutType.indexOf("1")!=-1){
                rowStr.param3.push(1);
            }
            if(rowStr.aboutType.indexOf("2")!=-1){
                rowStr.param1.push(2);
            }
            if(rowStr.aboutType.indexOf("3")!=-1){
                rowStr.param1.push(1);
            }
            if(rowStr.aboutType.indexOf("4")!=-1){
                rowStr.param2.push(2);
            }
            if(rowStr.aboutType.indexOf("5")!=-1){
                rowStr.param2.push(1);
            }
          this.$refs.childUpdate.open(rowStr);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("common.search") == clickName ){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if("新增" == clickName || window.$t("common.addNew") == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        // console.log('Submit data: ', model);
        //根据是否包含id更新还是添加
          let adverInfo={"sort":model.sort,"adType":model.positionType,"imgUrl":model.url,"linkUrl":model.address,"title":model.title,"content":model.content}
          model.adverInfo=JSON.stringify(adverInfo);
          if(model.channel==null || model.channel==undefined || model.channel==''){
              model.channel='';
          }else if(model.channel.length>1){
             model.channel= model.channel.join(",");
          }else{
              model.channel=model.channel[0]+"";
          }
          if(model.userLevel==null || model.userLevel==undefined || model.userLevel==''){
              model.userLevel='';
          }else if(model.userLevel.length>1){
             model.userLevel=model.userLevel.join(",");
          }else{
              model.userLevel=model.userLevel[0]+"";
          }
          if(model.isActive.length>1){
             model.isActive=model.isActive.join(",");
          }else{
              model.isActive=model.isActive.toString();
          }
          if(model.time!=undefined && model.time.length>1){
            model.endTime=model.time[1];
            model.startTime=model.time[0];
          }
          if(model.platform.length>1){
            model.platform=model.platform.join(",");
          }else{
              model.platform=model.platform.toString();
          }
          if(model.accountType.length>1){
             model.accountType=model.accountType.join(",");
          }else{
              model.accountType=model.accountType.toString();
          }
          model.aboutType='';
          //模拟
          for(let i in model.param1){
              if(model.param1[i]==1){
                  //未转换
                  model.aboutType+="3,";
              }else if(model.param1[i]==2){
                  //有转换
                  model.aboutType+="2,";
              }
          }
          //真实
          for(let i in model.param2){
              if(model.param1[i]==1){
                  //未转换
                  model.aboutType+="5,";
              }else if(model.param1[i]==2){
                  //有转换
                  model.aboutType+="4,";
              }
          }
          //模拟真实转换
          if(model.param3.length>0){
              model.aboutType+="1,";
          }
          model.aboutType=model.aboutType.substring(0,model.aboutType.lastIndexOf(","));
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.advertising.edit:URL.advertising.save,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
          this.$refs.childTable.
          defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},

        /*新增或更新*/
        updateData:{
          cols:[
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title: window.$t("mis.advertising.name"), field: 'name'},
                          { title: window.$t("mis.advertising.platform"), field: 'platform',type:2,optionList:platFromList},
                          { title: window.$t("mis.advertising.term"), field: 'term'},
                          { title: window.$t("mis.advertising.accountType"), field: 'accountType'},
                          { title: window.$t("mis.advertising.isActive"), field: 'isActive'},
                          { title: window.$t("mis.advertising.userLevel"), field: 'userLevel'},
                          { title: window.$t("mis.advertising.aboutType"), field: 'aboutType'},
                          { title: window.$t("mis.advertising.position"), field: 'position'},
                          { title: window.$t("mis.advertising.channel"), field: 'channel'},
                          {click:window.$t("common.search")},
                          {click:window.$t("common.addNew"),auth:"sys:advertising:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.advertising.query, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
                          {title:'id',field:'id',hidden:true},
                          { title: window.$t("mis.advertising.name"), field: 'name'},
                          { title: window.$t("mis.advertising.channel"), field: 'channel',render:(data)=>{
                                if(data.indexOf(",")!=-1){
                                    let temp=data.split(",");
                                    let str="";
                                    temp.forEach(item => {
                                        let app = channelAppList.find(({ id }) => id == item); // Find the app name by id
                                        let channelName = app ? app.name : item; 
                                        str+=channelName+","; 
                                    });
                                    return str.substring(0,str.lastIndexOf(","));
                                }else {
                                    let app = channelAppList.find(({ id }) => id == data); // Find the app name by id
                                    return app ? app.name : data;
                                }
                          }}, // string of channel app ids
                          { title: window.$t("mis.advertising.accountType"), field: 'accountType',render:(data)=>{
                              if(data.indexOf(",")!=-1){
                                  let temp=data.split(",");
                                  let str="";
                                  for (let i in temp){
                                      for (let j in accountTypeList){
                                          if(accountTypeList[j].key == temp[i]){
                                              str += accountTypeList[j].value+",";
                                          }
                                      }
                                  }
                                  return  str.substring(0,str.lastIndexOf(","));
                              }else{
                                  for (let j in accountTypeList){
                                      if(accountTypeList[j].key == data){
                                          return accountTypeList[j].value;
                                      }
                                  }
                              }
                              }},
                          { title: window.$t("mis.advertising.aboutType"), field: 'aboutType',render:(data)=>{
                              if(data==null || data ==undefined || data==''){
                                  return '';
                              }else if(data.indexOf(",")!=-1){
                                  let temp=data.split(",");
                                  let str="";
                                  for (let i in temp){
                                      str += change[temp[i]]+",";
                                  }
                                  return  str.substring(0,str.lastIndexOf(","));
                              }else{
                                  return change[data];
                              }
                              }},
                          { title: window.$t("mis.advertising.userLevel"), field: 'userLevel'},
                          { title: window.$t("mis.advertising.isActive"), field: 'isActive',render:(data)=>{
                              if(data.indexOf(",")!=-1){
                                  let temp=data.split(",");
                                  let str="";
                                  for (let i in temp){
                                      for (let j in isActiveList){
                                          if(isActiveList[j].key == temp[i]){
                                              str += isActiveList[j].value+",";
                                          }
                                      }
                                  }
                                  return  str.substring(0,str.lastIndexOf(","));
                              }else{
                                  for (let j in isActiveList){
                                      if(isActiveList[j].key == data){
                                          return isActiveList[j].value;
                                      }
                                  }
                              }
                              }},
                          { title:  window.$t("mis.advertising.adverInfo"), field: 'adverInfo'},
                          { title: window.$t("mis.advertising.startTime"), field: 'startTime',render:(data,full)=>{
                                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                              }},
                          { title: window.$t("mis.advertising.endTime"), field: 'endTime',render:(data,full)=>{
                                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                              }},
                          { title: window.$t("mis.advertising.platform"), field: 'platform'},
                          { title: window.$t("mis.advertising.position"), field: 'position',render:(data)=>{
                              for (let i in position){
                                  if(position[i].key == data){
                                      return position[i].value;
                                  }
                              }
                              return '';
                              }},
                          { title: window.$t("mis.advertising.status"), field: 'status',render:(data)=>{
                              if(data == 1)
                                  return window.$t("common.start");
                              return window.$t("common.stop");
                              }},
                          { title: window.$t("mis.advertising.createTime"), field: 'createDate'},
                          {title:window.$t("common.handle"),btnClick:[{name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:advertising:delete"},{name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:advertising:edit"}]},

          ]
        }
      }
    },
    created(){
        const getAdvertisingData = this.$axios.get(URL.advertising.getData);
        const getChannelData = this.$axios.post(URL.advertising.channelAppGetData, Qs.stringify({type:16})); // Type: 16 廣告渠道

        axios.all([getAdvertisingData, getChannelData]).then(axios.spread((advertisingResponse, channelResponse) => {
            if (advertisingResponse.code == 0 && channelResponse.code == 0) {
                // From Advertising
                let advertisingResult = advertisingResponse.result
                platFromList=advertisingResult.platform;
                termList=advertisingResult.term;
                accountTypeList=advertisingResult.accountType;
                changeStatusList=advertisingResult.changeStatus;
                isActiveList=advertisingResult.isActive;
                userLevel=advertisingResult.userLevel;
                position=advertisingResult.position;
                channel=advertisingResult.channel;
                dfreList=advertisingResult.dfre;//dfre
                cfVn=advertisingResult.cfVn;//cfVn
                informationPackage=advertisingResult.informationPackage;//资讯包
                carapace=advertisingResult.carapace;//马甲包
                tcList=advertisingResult.tcList;//tc
                stockPackage=advertisingResult.stockPackage;//股票包
                multiService=advertisingResult.multiService;//多业务
                kyy=advertisingResult.kyy;//快应用
                // From Channel
                let channelResult = channelResponse.result.list ? channelResponse.result.list : channelResponse.result;
                channelOptionList = channelResult.map(({channelKey, channelName, channelApps}) => ({value: channelKey, label: channelName, children: channelApps}))
                channelOptionList = channelOptionList.map(item => {
                    return {
                        ...item,
                        children: item.children.map(({id, name}) => ({value: id, label: name}))
                    }});
                channelAppList = channelResult.flatMap(item => item.channelApps);

                // Set columns
                this.formData.cols =[
                    { title: window.$t("mis.advertising.name"), field: 'name'},
                    { title: window.$t("mis.advertising.platform"), field: 'platform',type:2,optionList:platFromList},
                    { title: window.$t("mis.advertising.term"), field: 'term',type:2,optionList:termList},
                    { title: window.$t("mis.advertising.accountType"), field: 'accountType',type:2,optionList:accountTypeList},
                    { title: window.$t("mis.advertising.isActive"), field: 'isActive',type:2,optionList:isActiveList},
                    { title: window.$t("mis.advertising.userLevel"), field: 'userLevel',type:2,optionList:userLevel},
                    { title: window.$t("mis.advertising.aboutType"), field: 'aboutType',type:2,optionList:change},
                    { title: window.$t("mis.advertising.position"), field: 'position',type:2,optionList:position},
                    { title: window.$t("mis.advertising.channel"), field: 'channel',type:2,optionList:channel},
                    {click:window.$t("common.search"),auth:"sys:advertising:view"},
                    {click:window.$t("common.addNew"),auth:"sys:advertising:save"}
                ];
                this.updateData.cols=[
                    {title:'id',field:'id',hidden:true},
                    { title:window.$t("mis.advertising.name"), field: 'name'},
                    { title: window.$t("mis.advertising.channel"), field: 'channel', type: 15, optionList: channelOptionList, props: cascaderProps, data: []},
                    { title: window.$t("mis.advertising.time"), field: 'time',type:9},
                    { title: window.$t("mis.advertising.accountType"), field: 'accountType',type:4,optionList:accountTypeList,data:[],hasCheckAll:true,checkAll:false},
                    { title: window.$t("mis.advertising.param"), field: 'param1',type:4,optionList:changeStatusList,data:[],hasCheckAll:true,checkAll:false,checkAllName:window.$t("mis.advertising.simulation"),isNumber:true},
                    { title: '', field: 'param2',type:4,optionList:changeStatusList,data:[],hasCheckAll:true,checkAll:false,checkAllName:window.$t("mis.advertising.real"),isNumber:true},
                    { title: ' ', field: 'param3',type:4,optionList:changeStatusAccount,data:[],hasCheckAll:true,checkAll:false,checkAllName:window.$t("mis.advertising.demoCaseReal"),isNumber:true},
                    { title: window.$t("mis.advertising.isActive"), field: 'isActive',type:4,optionList:isActiveList,data:[],hasCheckAll:true,checkAll:false},
                    { title: window.$t("mis.advertising.userLevel"), field: 'userLevel',type:4,optionList:userLevel,data:[],hasCheckAll:true,checkAll:false},
                    { title: window.$t("mis.advertising.platform"), field: 'platform',type:4,optionList:platFromList,data:[],hasCheckAll:true,checkAll:false},
                    { title: window.$t("mis.advertising.position"), field: 'position',type:2,optionList:position,isNumber:true},
                    { title: window.$t("mis.advertising.positionType"), field: 'positionType',type:2,optionList:positionType,isNumber:true},
                    { title: window.$t("mis.advertising.url"), field: 'url',upload:true,action:  URL.advertising.upload},
                    { title: window.$t("mis.advertising.title"), field: 'title'},
                    { title: window.$t("mis.advertising.address"), field: 'address'},
                    { title: window.$t("mis.advertising.content"), field: 'content',textType:"textarea"},
                    { title: window.$t("mis.advertising.sort"), field: 'sort',type:7,data:0}
                ]
            } else {
                this.$message.error('Advertising Data Request Seems Failed: ', advertisingResponse.message);
                this.$message.error('Channel Data Request Seems Failed: ', channelResponse.message);
            }
        })).catch(error => console.log('Fetching data error:', error))
    }
  }
</script>
